import React from 'react'
import { Carousel } from '@trendyol-js/react-carousel'

/**
 * Componente para mostrar el equipo de trabajo. La información se carga dinámicamente desde
 * el archivo src/data/data.json -> "Team" tanto para visualización desktop como mobile.
 * Desktop usa imgDesktop si está disponible, de lo contrario usa img
 *
 * @component
 * @example
 * 
 * "Team": [
    {
      "img": "img/team/JuanIgnacio_mob.webp",
      "name": "Juan Ignacio Gallego",
      "namemob": "Juan Ignacio <br>Gallego",
      "job": "CEO",
      "text": "Con más de dos décadas impulsando marcas líderes en países como México, Colombia
      y España. Dirige con una estrategia magistral y además es un cocinero amateur experto en mimar
      a los paladares de sus hijos."
    }
  ]
 */

export const Team = (props) => {
  const [width, setWidth] = React.useState(window.innerWidth)
  const breakpoint = 620

  React.useEffect(() => {
    /* Inside of a "useEffect" hook add an event listener that updates
       the "width" state variable when the window size changes */
    window.addEventListener('resize', () => setWidth(window.innerWidth))

    /* passing an empty array as the dependencies of the effect will cause this
       effect to only run when the component mounts, and not each time it updates.
       We only want the listener to be added once */
  }, [])
  if (props.data) {
    return (
      <div id="team" className="text-center">
        <div className="container-fluid padding-fluid">
          <hr className="hrGeneral"></hr>
          <div className="col-md-8 col-md-offset-2 section-title">
            <h2>
              Nuestro <span className="title">Equipo</span>
            </h2>
          </div>
          <div className="row">
            {width < breakpoint ? (
              <div id="dvCarousel" className="col-xs-12 col-md-8">
                <Carousel
                  show={1}
                  slide={1}
                  swipeOn={0.2}
                  transition={0.2}
                  swiping={true}
                  responsive={true}
                  infinite={true}
                  rightArrow={
                    width < breakpoint ? (
                      <div className="vertical-center-news1">
                        <div className="vertical-center-news2">
                          <button
                            aria-label="rigth"
                            type="button"
                            className="btn btn-custom vertical-center-button-team-rigth"
                          >
                            <i className="fa-solid fa-angle-right fa-xs"></i>
                          </button>
                        </div>
                      </div>
                    ) : null
                  }
                  leftArrow={
                    width < breakpoint ? (
                      <div className="vertical-center-news1">
                        <div className="vertical-center-news2">
                          <button
                            aria-label="rigth"
                            type="button"
                            className="btn btn-custom vertical-center-button-team-left"
                          >
                            <i className="fa-solid fa-angle-left fa-xs"></i>
                          </button>
                        </div>
                      </div>
                    ) : null
                  }
                >
                  {props.data.map((d, i) => (
                    <div key={`dv1${i}`}>
                      <div key={`dv2${i}`}>
                        <img
                          className="img-responsive"
                          key={`img${i}`}
                          alt={d.name}
                          src={d.img}
                        />
                        <div className="nameCarousel">
                          <span
                            dangerouslySetInnerHTML={{ __html: d.namemob }}
                          ></span>
                        </div>
                        <div className="jobCarousel">{d.job}</div>
                      </div>
                      <div className="textCarousel">
                        <span className="vertical-center-team">{d.text}</span>
                      </div>
                      {/* <div className="thumbnail">
                      <div className="gradient">
                        <img src={d.img} alt={d.name} className="team-img" />
                        <span className="caption">
                          <h4>{d.name}</h4>
                        </span>
                        <span className="job">
                          {d.job}
                        </span>
                        <span className="text">
                          {d.text}
                        </span>
                      </div>
                    </div> */}
                    </div>
                  ))}
                </Carousel>
              </div>
            ) : (
              <div>
                <div className="col-md-12">
                  {props.data.slice(0, 7).map((d, i) => (
                    <div key={`team-${i}`} className="col-md-3 col-sm-6 team">
                      <div className="thumbnail">
                        <div className="gradient">
                          <img
                            src={d.imgDesktop || d.img}
                            alt={d.name}
                            className="team-img"
                          />
                          <span className="caption">
                            <h4>{d.name}</h4>
                          </span>
                          <span className="job">{d.job}</span>
                          <span className="text">{d.text}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                {props.data.length > 7 && (
                  <div className="col-md-12">
                    {props.data.slice(7).map((d, i) => (
                      <div key={`team-${i + 7}`} className="col-md-3 col-sm-6 team">
                        <div className="thumbnail">
                          <div className="gradient">
                            <img
                              src={d.imgDesktop || d.img}
                              alt={d.name}
                              className="team-img"
                            />
                            <span className="caption">
                              <h4>{d.name}</h4>
                            </span>
                            <span className="job">{d.job}</span>
                            <span className="text">{d.text}</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
            <div className="col-md-12 col-xs-12">&nbsp;</div>
            <div className="col-md-12 col-xs-12">&nbsp;</div>
          </div>
        </div>
      </div>
    )
  } else return <div></div>
}
